module.exports = __webpack_public_path__ + "img/flamethrower-turret-base-east.70291dde.png";